<template>
  <div class="attendance-list">
    <el-table
      :data="attendanceList"
      border
      style="width: 100%"
      tooltip-effect="dark"
      class="common-edit-button"
    >
      <el-table-column
        prop="studentName"
        :show-overflow-tooltip="true"
        label="学生"
      >
      </el-table-column>
      <el-table-column
        prop="attendanceType"
        :show-overflow-tooltip="true"
        label="动态"
      >
      </el-table-column>
      <el-table-column
        prop="attendanceAddress"
        label="地点"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="attendanceTimes"
        label="时间"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span :class="scope.row.attendanceStatus == '正常' ? 'normal' : scope.row.attendanceStatus == '异常' ? 'abnormal' : 'leave'">
            {{ scope.row.attendanceStatus }}
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    attendanceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "./attendance-list.scss";
</style>